import { z } from 'zod';
import { STATUS_IDS } from '../../domain/combat/statuses';
import { ELEMENTS } from '../../domain/game/elements';
import { FACTIONS } from '../../domain/game/factions';

const enemySkillSchema = z.object({
  id: z.string().min(1),
  name: z.string().min(1),
  faction: z.enum(FACTIONS),
  element: z.enum(ELEMENTS),
  accuracy: z.number().min(0).max(1),
  effect: z.discriminatedUnion('type', [
    z.object({ type: z.literal('lethal_attack') }),
    z.object({
      type: z.literal('player_status'),
      statusId: z.enum(STATUS_IDS),
      turns: z.number().int().positive(),
      potency: z.number().optional(),
    }),
  ]),
});

export type EnemySkill = z.infer<typeof enemySkillSchema>;

export const enemySkills: EnemySkill[] = z.array(enemySkillSchema).parse([
  {
    id: 'rusted_cleave',
    name: 'Trảm Kích Rỉ Sét',
    faction: 'demon',
    element: 'physical',
    accuracy: 0.72,
    effect: { type: 'lethal_attack' },
  },
  {
    id: 'terror_web',
    name: 'Tơ Khiếp Đảm',
    faction: 'demon',
    element: 'dark',
    accuracy: 0.84,
    effect: { type: 'player_status', statusId: 'fear', turns: 2 },
  },
  {
    id: 'venom_fang',
    name: 'Nanh Độc',
    faction: 'demon',
    element: 'physical',
    accuracy: 0.78,
    effect: { type: 'lethal_attack' },
  },
  {
    id: 'dread_aura',
    name: 'Khí Tức Kinh Hoàng',
    faction: 'demon',
    element: 'dark',
    accuracy: 0.82,
    effect: { type: 'player_status', statusId: 'fear', turns: 2 },
  },
  {
    id: 'executioner_blade',
    name: 'Kiếm Hành Quyết',
    faction: 'demon',
    element: 'physical',
    accuracy: 0.74,
    effect: { type: 'lethal_attack' },
  },
  {
    id: 'commanding_roar',
    name: 'Ma Lệnh Áp Chế',
    faction: 'demon',
    element: 'dark',
    accuracy: 0.88,
    effect: { type: 'player_status', statusId: 'fear', turns: 2 },
  },
  {
    id: 'infernal_strike',
    name: 'Địa Ngục Kích',
    faction: 'demon',
    element: 'fire',
    accuracy: 0.8,
    effect: { type: 'lethal_attack' },
  },
  {
    id: 'surprise_stab',
    name: 'Đâm Lén',
    faction: 'human',
    element: 'physical',
    accuracy: 0.8,
    effect: { type: 'lethal_attack' },
  },
]);

export function getEnemySkillById(id: string): EnemySkill | undefined {
  return enemySkills.find((skill) => skill.id === id);
}
